<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "App"
}
</script>

<style>
.marginb20 {
  margin-bottom: 20px;
}
.text-overflow {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
* {
  font-family: "Poppins", "Arial", sans-serif;
  word-break: break-word;
}
:root {
  --main-theme-color: #e7141a;
  --sub-theme-color: #b7080d;
}
/*按钮*/
.btn-primary {
  color: #fff;
  background-color: var(--main-theme-color) !important;
  border-color: var(--main-theme-color) !important;
}
.btn-primary:hover {
  color: #fff !important;
  background-color: var(--sub-theme-color) !important;
  border-color: var(--sub-theme-color) !important;
}
.btn-primary.active,
.btn-primary:active,
.open > .dropdown-toggle.btn-primary {
  color: #fff !important;
  background-color: var(--sub-theme-color) !important;
  border-color: var(--sub-theme-color) !important;
}
.btn-primary.focus,
.btn-primary:focus {
  color: #fff !important;
  background-color: var(--sub-theme-color) !important;
  border-color: var(--sub-theme-color) !important;
}
.btn-primary.active.focus,
.btn-primary.active:focus,
.btn-primary.active:hover,
.btn-primary:active.focus,
.btn-primary:active:focus,
.btn-primary:active:hover,
.open > .dropdown-toggle.btn-primary.focus,
.open > .dropdown-toggle.btn-primary:focus,
.open > .dropdown-toggle.btn-primary:hover {
  color: #fff !important;
  background-color: var(--sub-theme-color) !important;
  border-color: var(--sub-theme-color) !important;
  outline: none;
}
/*table*/
table {
  border-collapse: collapse;
  border-spacing: 0;
  table-layout: fixed;
}
table tr td {
  border: 1px solid #ddd;
  padding: 10px;
}
table tr:nth-child(odd) {
  background-color: #fff;
}
table tr:nth-child(even) {
  background-color: #f9f9f9;
}
/* pagination_style */
.pagination > .active > a,
.pagination > .active > a:focus,
.pagination > .active > a:hover,
.pagination > .active > span,
.pagination > .active > span:focus,
.pagination > .active > span:hover {
  background-color: var(--main-theme-color);
  border-color: var(--main-theme-color);
}
.pagination > li > a,
.pagination > li > span {
  color: var(--main-theme-color);
}
/*内页推荐内容的轮播*/
.recommend-section .owl-dots {
  text-align: center;
}
.recommend-carousel.owl-carousel button.owl-dot span {
  background-color: #222;
  border-radius: 30px;
  display: inline-block;
  height: 8px;
  width: 8px;
  margin: 0 5px;
  -webkit-transition: all 0.5s linear 0s;
  transition: all 0.5s linear 0s;
}
.recommend-carousel.owl-carousel button.owl-dot.active span {
  background-color: var(--main-theme-color);
}
.recommend-carousel.owl-carousel .owl-nav button.owl-prev,
.recommend-carousel.owl-carousel .owl-nav button.owl-next {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 32px;
  height: 30px;
  cursor: pointer;
  border: 2px solid var(--main-theme-color);
  border-radius: 50%;
  color: var(--main-theme-color);
  font-size: 22px;
  transition: 0.5s;
}
.recommend-carousel.owl-carousel .owl-nav button.owl-prev {
  left: 0;
}
.recommend-carousel.owl-carousel .owl-nav button.owl-next {
  right: 0;
}
.recommend-carousel.owl-carousel .owl-nav button.owl-prev:hover,
.recommend-carousel.owl-carousel .owl-nav button.owl-next:hover {
  background-color: var(--main-theme-color);
  color: #fff;
}
/*面包屑导航*/
.breadcrumb_nav_box .fa.fa-home {
  color: #666;
}
.breadcrumb_nav_box a {
  color: var(--main-theme-color);
  text-decoration: none;
  font-weight: 600;
}
.breadcrumb_nav_img {
  background-color: var(--main-theme-color);
}
.breadcrumb_nav_img img {
  opacity: 0.5;
}
.breadcrumb_nav .breadcrumb_nav_title {
  color: #ffffff;
  margin: 0;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 90%;
  font-weight: normal;
  font-size: 40px;
}
.breadcrumb_nav_box .breadcrumb_nav_position {
  text-transform: none;
}
.breadcrumb_nav_box span {
  text-transform: capitalize;
}
.breadcrumb_nav_wrap {
  padding: 13px 0;
  background-color: #ececec;
}
.breadcrumb_nav_list {
  margin: 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
}
.breadcrumb_nav_list li {
  margin: 0;
  padding: 0;
  list-style: none;
  margin-right: 10px;
}
.breadcrumb_nav_list li a {
  text-transform: capitalize;
}
.breadcrumb_nav_list li a:hover {
  color: var(--main-theme-color);
}
.breadcrumb_nav_list li i {
  margin-right: 4px;
}
[dir="rtl"] .breadcrumb_nav_list li i {
  margin-right: 0;
  margin-left: 4px;
}
[dir="rtl"] .breadcrumb_nav_list li {
  margin-left: 10px;
}

.d-flex {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}
.align-items-center {
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}
.justify-content-center {
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
}
.justify-content-between {
  -webkit-box-pack: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  justify-content: space-between;
}
.justify-content-around {
  -webkit-box-pack: space-around;
  -webkit-justify-content: space-around;
  -ms-flex-pack: space-around;
  justify-content: space-around;
}
.justify-content-end {
  -webkit-box-pack: flex-end;
  -webkit-justify-content: flex-end;
  -ms-flex-pack: flex-end;
  justify-content: flex-end;
}
.flex-nowrap {
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
}

.clamp {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  line-clamp: 1;
  -webkit-line-clamp: 1;
}
.clamp2 {
  line-clamp: 2;
  -webkit-line-clamp: 2;
}
.clamp3 {
  line-clamp: 3;
  -webkit-line-clamp: 3;
}
.clamp4 {
  line-clamp: 4;
  -webkit-line-clamp: 4;
}
.clamp5 {
  line-clamp: 5;
  -webkit-line-clamp: 5;
}

[lang="es"] .site_header_bottom .searchbox {
  padding: 28px 20px 0 14px;
}
[lang="es"] .site_header_bottom .main-menu > li > a,
[lang="ru"] .site_header_bottom .main-menu > li > a {
  font-size: 19px;
  margin: 17px 8px;
}
[lang="fr"] .site_header_bottom .main-menu > li > a,
[lang="de"] .site_header_bottom .main-menu > li > a,
[lang="it"] .site_header_bottom .main-menu > li > a,
[lang="pl"] .site_header_bottom .main-menu > li > a,
[lang="pt"] .site_header_bottom .main-menu > li > a,
[lang="ms"] .site_header_bottom .main-menu > li > a {
  margin: 17px 10px;
}
[dir="rtl"] .site_header_top .contact-item {
  padding-right: 0;
  padding-left: 44px;
}
[dir="rtl"] .site_header_top .contact-item:last-child {
  padding-left: 0;
}
[dir="rtl"] .site_header_bottom .main-menu > li {
  float: right;
}
[dir="rtl"] .site_header_bottom .searchbox {
  position: relative;
}
[dir="rtl"] .search_g_box {
  left: 0;
  right: auto;
}
[dir="rtl"] .search_g_box form button {
  position: absolute;
  left: 20px;
  top: 16px;
  border-radius: 3px 0 0 3px;
}
[dir="rtl"] .search_g_box form input {
  margin-left: 38px;
}
[dir="rtl"] .home-sub-title .title-line1::before {
  left: 0;
  right: auto;
}
[dir="rtl"] .index-case-part .case-info-right {
  text-align: left;
}
[dir="rtl"] .index-case-part .case-info-left {
  margin-left: 15px;
  margin-right: 0;
}
[dir="rtl"] .index-inquiry-part .contact-item a {
  padding-left: 0;
  padding-right: 30px;
}
[dir="rtl"] .index-inquiry-part .contact-item i.fa {
  right: 0;
  left: 0;
}
[dir="rtl"] .index-inquiry-part .inquiry-form .form-group1 {
  text-align: left;
}

@media (max-width: 1199px) {
  .breadcrumb_nav .breadcrumb_nav_title {
    font-size: 30px;
  }
}
@media (min-width: 992px) {
  [dir="rtl"] .index-about-part .about-left {
    padding-left: 40px;
    padding-right: 0;
  }
}
@media (max-width: 991px) {
  .breadcrumb_nav .breadcrumb_nav_title {
    font-size: 24px;
  }
}
@media (max-width: 767px) {
  .site_header_bottom .h-logo img {
    max-width: 190px !important;
  }
}
@media (min-width: 768px) {
  [dir="rtl"] .site_header_top .lang_dropdown {
    float: left;
  }
}
</style>
